module.exports = __webpack_public_path__ + "media/bgm_zhuanbei.ef9aa806.mp3";